import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

export default function OurCoverage() {
  const locations = [
    "Aljada & Tilal City",
    "Al Majaz & Al Khan",
    "Industrial Area & Barashi",
    "Hoshi & Al Tai",
    "Maryam Island & Ajmal Makan Waterfront",
    "Al Zorah & Al Yasmeen",
    "JVC & JVT",
    "MBR City & Meydan City",
    "Al Jaddaf & Culture Village",
  ];

  return (
    // <Box
    //   sx={{
    //     py: { xs: 12, md: 18 },
    //     backgroundColor: "var(--color-primary-dark)",
    //     position: "relative",
    //     overflow: "hidden",
    //   }}
    // >
    <Box
      sx={{
        py: { xs: 3, md: 6 },
        backgroundColor: "var(--color-bg)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
            gap: { xs: 6, md: 12 },
            alignItems: "center",
          }}
        >
          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.85 }}
            viewport={{ once: true }}
          >
            {/* EYEBROW */}
            <Typography
              sx={{
                letterSpacing: "0.26em",
                fontSize: 12,
                fontWeight: 600,
                color: "var(--color-gold)",
                mb: 3,
              }}
            >
              OUR COVERAGE
            </Typography>

            {/* TWO-COLOR HEADING */}
            <Typography
              sx={{
                fontSize: {
                  xs: "2.2rem",
                  sm: "2.7rem",
                  md: "3.2rem",
                  lg: "3.6rem",
                },
                fontWeight: 600,
                lineHeight: 1.15,
                maxWidth: 680,
                mb: 3,
              }}
            >
              <Box component="span" sx={{ color: "var(--color-text-primary)" }}>
                Operating Across
              </Box>{" "}
              <Box component="span" sx={{ color: "var(--color-gold)" }}>
                Prime Locations
              </Box>
              <br />
              <Box component="span" sx={{ color: "var(--color-text-primary)" }}>
                In Sharjah
              </Box>
            </Typography>

            {/* DESCRIPTION */}
            <Typography
              sx={{
                fontSize: { xs: 14, md: 16 },
                lineHeight: 1.9,
                // color: "rgba(255,255,255,0.8)",
                color: "var(--color-text-muted)",

                maxWidth: 620,
                mb: 5,
              }}
            >
              Vision X Nexus delivers expert real estate services across
              Sharjah’s most sought-after residential, commercial, and
              investment destinations. Our deep local knowledge enables accurate
              insights, competitive positioning, and tailored strategies for
              every client.
            </Typography>

            {/* LOCATION LIST */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 2.5,
                maxWidth: 620,
              }}
            >
              {locations.map((item, index) => (
                // <Box
                //   key={index}
                //   sx={{
                //     display: "flex",
                //     alignItems: "center",
                //     gap: 1.5,
                //     p: 1.5,
                //     borderRadius: 2,
                //     transition: "all 0.35s ease",
                //     cursor: "default",
                //     backgroundColor: "rgba(207,172,106,0.08)",
                //     "&:hover": {
                //       backgroundColor: "rgba(207,172,106,0.08)",
                //     },
                //   }}
                // >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    p: 1.5,
                    borderRadius: 2,
                    transition: "all 0.3s ease",
                    backgroundColor: "rgba(207,172,106,0.12)",

                    "&:hover": {
                      backgroundColor: "rgba(207,172,106,0.2)",
                    },
                  }}
                >
                  <LocationOnOutlinedIcon
                    sx={{
                      color: "var(--color-gold)",
                      fontSize: 18,
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: 14,
                      // color: "var(--color-white)",
                      color: "var(--color-text-primary)",
                    }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>
          </motion.div>

          {/* RIGHT MAP */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                position: "relative",
                borderRadius: 4,
                overflow: "hidden",
                boxShadow: "0 35px 80px rgba(0,0,0,0.22)",
                height: { xs: 320, md: 520 },
              }}
            >
              {/* <Box
              sx={{
                position: "relative",
                borderRadius: 4,
                overflow: "hidden",
                boxShadow: "0 60px 120px rgba(0,0,0,0.75)",
              }}
            > */}
              {/* MAP IFRAME */}
              <Box
                component="iframe"
                src="https://www.google.com/maps?q=Sharjah&output=embed"
                loading="lazy"
                sx={{
                  width: "100%",
                  height: "100%",
                  border: 0,
                  // filter: "grayscale(1) contrast(1.1)",
                }}
              />

              {/* DARK OVERLAY */}
              {/* <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(0,0,0,0.15), rgba(0,0,0,0.6))",
                  pointerEvents: "none",
                }}
              /> */}

              {/* GOLD FRAME */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  border: "1px solid rgba(207,172,106,0.45)",
                  borderRadius: 4,
                  pointerEvents: "none",
                }}
              />
            </Box>
          </motion.div>
        </Box>
      </Container>
      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
